export default __webpack_public_path__ + "static/media/badge-plug.f0cb55ed.svg";